import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { ClubsEntityNormalized } from '../../../../../../../../../store/product/types';
import { ClubsAssetProvider } from '../../../../../contexts/products/Clubs';
import { ItemDetails } from '../../Clubs/Details';

import { ClubsItemDesktop } from './desktop';
import { ClubsItemMobile } from './mobile';
import { ClubsItemTablet } from './tablet';

export namespace ClubsItemTypes {
  export interface Props {
    offer: ClubsEntityNormalized;
  }
}
export const ClubsItem: React.FC<ClubsItemTypes.Props> = (props) => {
  const clubsItem = useBreakpointValue({
    base: <ClubsItemMobile {...props} />,
    sm: <ClubsItemTablet {...props} />,
    lg: <ClubsItemDesktop {...props} />,
  });

  return (
    <ClubsAssetProvider>
      <ItemDetails />
      {clubsItem}
    </ClubsAssetProvider>
  );
};
